import mlsData from '../../data/mlsList';

const browse = () => {
    return mlsData;
};

const read = query => {
    let result;

    result = null;

    if (!query) {
        return false;
    }

    const key = typeof query === 'number' ? 'integer' : 'string';

    mlsData.forEach(item => {
        if (item[key] === query) {
            result = item;
        }
    });

    return result;
};

const mlsList = {
    browse,
    read
};

export default mlsList;
